import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/publicationProduct/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/publicationProduct/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/publicationProduct/FETCH_FAILURE'

const CREATE_REQUEST = 'realbase/publicationProduct/CREATE_REQUEST'
const CREATE_SUCCESS = 'realbase/publicationProduct/CREATE_SUCCESS'
const CREATE_FAILURE = 'realbase/publicationProduct/CREATE_FAILURE'

const UPDATE_REQUEST = 'realbase/publicationProduct/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realbase/publicationProduct/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realbase/publicationProduct/UPDATE_FAILURE'

export type PublicationProductsModuleState = {
  creating: boolean,
  errors: string[],
  loaded: boolean,
  loadedForKeys: string[],
  loadedIds: number[],
  loading: boolean,
  updating: boolean,
}

// Initial State
const initialState: PublicationProductsModuleState = {
  creating: false,
  errors: [],
  loaded: false,
  loadedForKeys: [],
  loadedIds: [],
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
    // @ts-expect-error TS2339
    loadedForKeys: payload.loadedForKeys,
  }
}

export function fetchSuccess() {
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest() {
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess() {
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []) {
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess() {
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Action Creators
// @ts-expect-error TS7006
export function loadPublicationProducts(options) {
  const { entityKey } = options || {}

  // @ts-expect-error TS7006
  return (dispatch, getState) => {
    const state = getState()
    const loadedForKeys = [...state.publicationProducts.loadedForKeys]

    if (entityKey && !loadedForKeys.includes(entityKey)){
      loadedForKeys.push(entityKey)
    }

    dispatch(fetchRequest({ loadedForKeys }))

    const promise = api('/publication_products.json', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PUBLICATION_PRODUCT_ARRAY)
        // @ts-expect-error TS2345
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        // @ts-expect-error TS2345
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// @ts-expect-error TS2304
export function loadPublicationProductIds(publicationProductIds: number[], options: EntityOptions = {}) {
  // @ts-expect-error TS2304
  return (dispatch: AppDispatch, getState: () => RootReducerState) => {
    const state = getState()
    const loadedIds = [...state.publicationProducts.loadedIds]
    const mergedIds = [...loadedIds, ...publicationProductIds]
    const uniqueIds = Array.from(new Set(mergedIds))

    const missingIds = publicationProductIds.filter(id => !loadedIds.includes(id))
    if (!missingIds.length){
      return new Promise((resolve) => {
        resolve({ success: true as const, data: [] })
      })
    }

    // Set Loading
    dispatch(fetchRequest({ loadedIds: uniqueIds }))

    const promise = api('/publication_products.json', { ...options, publication_product_ids: JSON.stringify(missingIds) })
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PUBLICATION_PRODUCT_ARRAY)
        // @ts-expect-error TS2345
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true as const, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        // @ts-expect-error TS2345
        dispatch(fetchFailure(errors))

        return { success: false as const, errors }
      })

    return promise
  }
}

// @ts-expect-error TS7006
export function createPublicationProduct(publicationProduct, options) {
  const config = {
    method: 'POST',
    data: JSON.stringify({
      publication_product: publicationProduct,
    }),
  }

  // @ts-expect-error TS7006
  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/publication_products.json', options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PUBLICATION_PRODUCT)
        // @ts-expect-error TS2345
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        // @ts-expect-error TS2345
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// @ts-expect-error TS7006
export function updatePublicationProduct(publicationProduct, options) {
  const config = {
    method: 'PUT',
    data: JSON.stringify({
      publication_product: publicationProduct,
    }),
  }

  // @ts-expect-error TS7006
  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/publication_products/${publicationProduct.id}.json`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PUBLICATION_PRODUCT)
        // @ts-expect-error TS2345
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        // @ts-expect-error TS2345
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        // @ts-expect-error TS2339
        loadedForKeys: action.loadedForKeys || state.loadedForKeys,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        // @ts-expect-error TS2339
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        // @ts-expect-error TS2339
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        // @ts-expect-error TS2339
        errors: action.errors,
      }
    default:
      return state
  }
}
